module.exports = __webpack_public_path__ + "assets/img/f729b4df7a58823984531dc1c633de5e.png";